import { clsx } from 'clsx';

export type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'promo';

export interface CommonButtonProps {
  bgcolor?: string;
  textcolor?: string;
  size?: ButtonSize;
  rounded?: string;
  isLoading?: boolean;
  isSubmitting?: boolean;
  disabled?: boolean;
  className?: string;
  leftIcon?: React.ReactNode;
}

const sizeStyles: Record<ButtonSize, string> = {
  xsmall: 'h-[43px] tablet:h-[64px] text-body-md tablet:text-body',
  small: 'h-[46px] tablet:h-[58px] text-body-bold',
  medium: 'h-[57px] big-text-body',
  large: 'h-[64px] text-lg',
  promo: 'h-[36px] text-body-sm !text-amberblack',
};

export const getButtonClasses = ({
  bgcolor = 'bg-button',
  textcolor = 'text-off-white',
  size = 'medium',
  rounded = 'rounded-full',
  isLoading,
  isSubmitting,
  disabled,
  className,
}: CommonButtonProps) => {
  const isDisabled = disabled || isLoading || isSubmitting;

  return clsx(
    'font-inter font-bold w-full tracking-3pct transition-all duration-500 ease-in-out flex items-center justify-center',
    bgcolor,
    isDisabled ? textcolor : 'text-paper',
    sizeStyles[size],
    rounded,
    {
      'cursor-pointer': !isDisabled,
      'bg-mediumgray text-lightgray cursor-not-allowed opacity-50': isDisabled,
    },
    className,
  );
};
